const BuildYourStarterKit = function() {
    function BuildYourStarterKit() {
        this.selector = {
            section_element: document.querySelector('.build-your-start-kit-section'),
            step1_products: document.querySelectorAll('.steps-diffuser-products.step-1'),
            step2_products: document.querySelectorAll('.steps-diffuser-products.step-2'),
            next_steps: document.querySelectorAll('.next-steps-button'),
            steps: document.querySelectorAll('.build-your-start-kit-section .build-your-start-kit-container .steps'),
            prev_steps: document.querySelectorAll('.previous-steps-button'),
            show_info: document.querySelectorAll('.show-product-info'),
            step1_progressbar: document.getElementById('step1-progressbar'),
            step2_progressbar: document.getElementById('step2-progressbar'),
            step3_progressbar: document.getElementById('step3-progressbar'),
            subscription_label: document.querySelectorAll('.build-your-start-kit-section .build-your-start-kit-container .steps[data-this-step="3"] > .final-steps-container .final-details .selling-plan label'),
            subscription_input: document.querySelectorAll('.build-your-start-kit-section .build-your-start-kit-container .steps[data-this-step="3"] > .final-steps-container .final-details .selling-plan .selling-plan-id'),
            arrow_steps: document.querySelectorAll('.build-your-start-kit-section .build-your-start-kit-container .steps .right-picker .right-content .products-picker label .details .price .arrow'),
            final_order_purchase: document.getElementById('final-order-purchase'),
            step2_replaceable_image: document.getElementById('step2_replaceable_image'),
            variant_selling_plan_selected: document.getElementById('variant_selling_plan_selected'),
            secondproductselectedimagerender: document.getElementById('second-product-selected-image-render')
        }
        this.discount = {
            onetime: this.selector.section_element ? this.selector.section_element.dataset.discountOnetime : 'FREESCENT',
            subscription: this.selector.section_element ? this.selector.section_element.dataset.discountSubscription : 'FREESCENT_SUB',
            delivery_frequency: this.selector.section_element ? this.selector.section_element.dataset.deliveryFrequency : 'null'
        }
        this.state = {
            first_product: null,
            second_product: null,
            selling_plan: null,
            discounted: {
                first_product: 0,
                second_product: 0
            },
            regular: {
                first_product: 0,
                second_product: 0
            },
            filteredVariantSellingPlan: []            
        }
        this.final = {
            first_product: {
                image: document.getElementById('first-product-selected-image'),
                title: document.getElementById('first-product-selected-title'),
                discount_price: document.getElementById('first-product-selected-discount-price'),
                regular_price: document.getElementById('first-product-selected-regular-price'),
                selling_plan: document.getElementById('first-product-selected-selling-plan')
            },
            second_product: {
                image: document.getElementById('second-product-selected-image'),
                title: document.getElementById('second-product-selected-title'),
                discount_price: document.getElementById('second-product-selected-discount-price'),
                regular_price: document.getElementById('second-product-selected-regular-price'),
                selling_plan: document.getElementById('second-product-selected-selling-plan')
            },
            selling_plan: {
                subscription: document.getElementById('final-selected-discounted-price'),
                onetimepurchase: document.getElementById('final-one-time-purchase-price'),
                finalorderdiscount: document.getElementById('final-order-discount'),
                finalorderregular: document.getElementById('final-order-regular'),
                finalplanname: document.getElementById('final-selected-selling-plan-name')
            } 
        }
        this.load();
    }
    BuildYourStarterKit.prototype.load = function() {
        var _ = this;
        if(_.selector.step1_products.length > 0) {
            _.selector.step1_products.forEach(el => {
                el.addEventListener('click', event => {
                    _.selector.step1_products.forEach(label => {
                        label.classList.remove('active');
                    })
                    event.target.closest('label').classList.add('active');
                    if(event.target.closest('label').classList.contains('active')) {
                        _.final.first_product.image.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage;
                        _.final.first_product.image.dataset.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage;
                        _.final.first_product.title.textContent = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantTitle;
                        _.final.first_product.regular_price.textContent = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantPrice;
                        _.state.first_product = event.target.closest('label').querySelector('input[type="radio"]').value;
                        const current_currency = el.querySelector('input[type="radio"]').dataset.currentCurrency;
                        const regular_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;
                        _.state.regular.first_product = regular_price;
                        // Update prices: discount shows total, regular shows just diffuser (second product is free)
                        const total_before_discount = parseInt(_.state.regular.first_product) + parseInt(_.state.regular.second_product);
                        _.final.selling_plan.finalorderdiscount.textContent = `${current_currency}${total_before_discount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                        const final_regular_price = parseInt(_.state.regular.first_product);
                        _.final.selling_plan.finalorderregular.textContent = `${current_currency}${final_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                        _.selector.subscription_input.forEach(detail => {
                            if(detail.checked) {
                                if(detail.value !== 'one-time-purchase') {
                                    const one_time_purchase_discount = parseInt(detail.dataset.oneTimePurchaseDiscount) * 0.01;
                                    const refined_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;                                
                                    const discounted_amount = refined_price * one_time_purchase_discount;
                                    const final_discounted_amount = refined_price - discounted_amount;
                                    _.final.first_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                    _.state.discounted.first_product = final_discounted_amount;
                                    _.final.selling_plan.finalorderdiscount.classList.remove('underline');
                                    _.final.selling_plan.finalorderregular.classList.add('underline');
                                    _.final.first_product.discount_price.classList.remove('underline');
                                }  else {
                                    const one_time_purchase_discount = parseInt(detail.dataset.oneTimePurchaseDiscount) * 0.01;
                                    const refined_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;                                
                                    const discounted_amount = refined_price * one_time_purchase_discount;
                                    const final_discounted_amount = refined_price - discounted_amount;
                                    _.final.first_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                    _.state.discounted.first_product = final_discounted_amount;
                                    _.final.selling_plan.finalorderdiscount.classList.add('underline');
                                    _.final.selling_plan.finalorderregular.classList.remove('underline');                                    
                                    _.final.first_product.discount_price.classList.add('underline');
                                }                         
                            }
                        })
                    }
                })
                if(el.closest('label').classList.contains('active')) {
                    _.state.first_product = el.querySelector('input[type="radio"]').value;
                    _.final.first_product.image.src = el.querySelector('input[type="radio"]').dataset.variantImage;
                    _.final.first_product.image.dataset.src = el.querySelector('input[type="radio"]').dataset.variantImage;
                    _.final.first_product.title.textContent = el.querySelector('input[type="radio"]').dataset.variantTitle;
                    _.final.first_product.regular_price.textContent = el.querySelector('input[type="radio"]').dataset.variantPrice;                  
                    const current_currency = el.querySelector('input[type="radio"]').dataset.currentCurrency;
                    const regular_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;
                    _.state.regular.first_product = regular_price;                   
                    // Update prices: discount shows total, regular shows just diffuser (second product is free)
                    const total_before_discount = parseInt(_.state.regular.first_product) + parseInt(_.state.regular.second_product);
                    _.final.selling_plan.finalorderdiscount.textContent = `${current_currency}${total_before_discount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                    const final_regular_price = parseInt(_.state.regular.first_product);
                    _.final.selling_plan.finalorderregular.textContent = `${current_currency}${final_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                    _.selector.subscription_input.forEach(detail => {
                        if(detail.checked) {
                            if(detail.value !== 'one-time-purchase') {
                                const one_time_purchase_discount = parseInt(detail.dataset.oneTimePurchaseDiscount) * 0.01;
                                const refined_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;                                
                                const discounted_amount = refined_price * one_time_purchase_discount;
                                const final_discounted_amount = refined_price - discounted_amount;
                                _.final.first_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                _.state.discounted.first_product = final_discounted_amount;
                                _.final.selling_plan.finalorderdiscount.classList.remove('underline');
                                _.final.selling_plan.finalorderregular.classList.add('underline');
                                _.final.first_product.discount_price.classList.remove('underline');
                            }  else {
                                const one_time_purchase_discount = parseInt(detail.dataset.oneTimePurchaseDiscount) * 0.01;
                                const refined_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;                                
                                const discounted_amount = refined_price * one_time_purchase_discount;
                                const final_discounted_amount = refined_price - discounted_amount;
                                _.final.first_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                _.state.discounted.first_product = final_discounted_amount;
                                _.final.selling_plan.finalorderdiscount.classList.remove('underline');
                                _.final.selling_plan.finalorderregular.classList.add('underline');
                                _.final.first_product.discount_price.classList.add('underline');
                            }                         
                        }
                    })
                }
            })
        }
        if(_.selector.step2_products.length > 0) {
            _.selector.step2_products.forEach(el => {
                el.addEventListener('click', event => {
                    _.selector.step2_products.forEach(label => {
                        label.classList.remove('active');
                    })
                    _.state.filteredVariantSellingPlan = [];
                    _.state.filteredVariantSellingPlan = window.second_products_selling_plan.filter(plan => plan.variantId === event.target.closest('label').querySelector('input[type="radio"]').value);
                    if(_.state.filteredVariantSellingPlan.length > 0) {
                        if(_.selector.variant_selling_plan_selected) {
                            _.selector.variant_selling_plan_selected.innerHTML = "";
                            _.state.filteredVariantSellingPlan.forEach((option, index) => {
                                var selling_plan_option = document.createElement("option");
                                selling_plan_option.value = option.sellingPlanId;
                                selling_plan_option.text = option.sellingPlanName;
                                selling_plan_option.dataset.sellingPlanPriceType = option.sellingPlanPriceType;
                                selling_plan_option.dataset.sellingPlanPriceValue = option.sellingPlanPriceValue;
                                selling_plan_option.dataset.variantId = option.variantId;
                                selling_plan_option.dataset.variantPrice = option.variantPrice;
                                selling_plan_option.dataset.currentCurrency = option.currentCurrency;
                                selling_plan_option.dataset.sellingPlanId = option.sellingPlanId;
                                index == 0 && (selling_plan_option.selected = true);
                                _.selector.variant_selling_plan_selected.append(selling_plan_option);
                            })                                
                        }                            
                    }
                    event.target.closest('label').classList.add('active');
                    if(event.target.closest('label').classList.contains('active')) {
                        _.selector.secondproductselectedimagerender && (_.selector.secondproductselectedimagerender.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage);
                        _.selector.secondproductselectedimagerender && (_.selector.secondproductselectedimagerender.dataset.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage);
                        _.selector.secondproductselectedimagerender && (_.selector.secondproductselectedimagerender.srcset = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage);
                        _.final.second_product.image.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage;
                        _.final.second_product.image.dataset.src = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantImage;
                        _.final.second_product.title.textContent = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantTitle;
                        _.final.second_product.regular_price.textContent = event.target.closest('label').querySelector('input[type="radio"]').dataset.variantPrice;
                        _.final.second_product.regular_price.classList.add('underline');
                        _.final.second_product.discount_price.classList.remove('underline');
                        _.state.second_product = event.target.closest('label').querySelector('input[type="radio"]').value;                       
                        const regular_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;
                        const current_currency = el.querySelector('input[type="radio"]').dataset.currentCurrency;
                        _.state.regular.second_product = regular_price;
                        const final_regular_price = parseInt(_.state.regular.first_product) + parseInt(_.state.regular.second_product);
                        _.final.selling_plan.finalorderregular.textContent = `${current_currency}${final_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                        _.final.selling_plan.finalplanname.textContent =`${_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].text}`;
                        _.selector.subscription_input.forEach(detail => {
                            if(detail.checked) {
                                if(detail.value !== 'one-time-purchase') {                                    
                                    const one_time_purchase_discount = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanPriceValue) * 0.01;
                                    const refined_price = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.variantPrice) / 100;                                
                                    const discounted_amount = refined_price * one_time_purchase_discount;
                                    const final_discounted_amount = refined_price - discounted_amount;
                                    _.final.second_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                    _.state.discounted.second_product = final_discounted_amount;
                                    _.final.selling_plan.subscription.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                    _.final.selling_plan.onetimepurchase.textContent = `${current_currency}${refined_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                    const total_final_discount =  _.state.regular.first_product + _.state.discounted.second_product;
                                    _.final.selling_plan.finalorderdiscount.textContent = `${current_currency}${ total_final_discount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                    _.final.selling_plan.finalorderdiscount.classList.remove('underline');
                                    _.final.selling_plan.finalorderregular.classList.add('underline');
                                    _.final.second_product.regular_price.classList.add('underline');
                                    _.final.second_product.discount_price.classList.remove('underline');
                                    detail.value = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
                                    _.state.selling_plan = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
                                }  else {
                                    const one_time_purchase_discount = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanPriceValue) * 0.01;
                                    const refined_price = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.variantPrice) / 100;                                
                                    const discounted_amount = refined_price * one_time_purchase_discount;
                                    const final_discounted_amount = refined_price - discounted_amount;
                                    _.final.second_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                    _.state.discounted.second_product = final_discounted_amount;
                                    const total_final_discount =  _.state.regular.first_product + _.state.discounted.second_product;
                                    _.final.selling_plan.finalorderdiscount.textContent = `${current_currency}${ total_final_discount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                    _.final.selling_plan.finalorderdiscount.classList.add('underline');
                                    _.final.selling_plan.finalorderregular.classList.remove('underline');
                                    _.final.second_product.regular_price.classList.remove('underline');
                                    _.final.second_product.discount_price.classList.add('underline');                                    
                                }                         
                            }
                        })
                    }
                })
                if(el.closest('label').classList.contains('active')) {                    
                    _.final.second_product.image.src = el.querySelector('input[type="radio"]').dataset.variantImage;
                    _.final.second_product.image.dataset.src = el.querySelector('input[type="radio"]').dataset.variantImage;
                    _.final.second_product.title.textContent = el.querySelector('input[type="radio"]').dataset.variantTitle;
                    _.final.second_product.regular_price.textContent = el.querySelector('input[type="radio"]').dataset.variantPrice;
                    _.final.selling_plan.onetimepurchase.textContent = el.querySelector('input[type="radio"]').dataset.variantPrice;
                    _.state.second_product = el.querySelector('input[type="radio"]').value;
                    _.state.filteredVariantSellingPlan = [];
                    _.state.filteredVariantSellingPlan = window.second_products_selling_plan.filter(plan => plan.variantId === el.querySelector('input[type="radio"]').value);
                    if(_.state.filteredVariantSellingPlan.length > 0) {
                        if(_.selector.variant_selling_plan_selected) {
                            _.selector.variant_selling_plan_selected.innerHTML = "";
                            _.state.filteredVariantSellingPlan.forEach((option, index) => {
                                var selling_plan_option = document.createElement("option");
                                selling_plan_option.value = option.sellingPlanId;
                                selling_plan_option.text = option.sellingPlanName;
                                selling_plan_option.dataset.sellingPlanPriceType = option.sellingPlanPriceType;
                                selling_plan_option.dataset.sellingPlanPriceValue = option.sellingPlanPriceValue;
                                selling_plan_option.dataset.variantId = option.variantId;
                                selling_plan_option.dataset.variantPrice = option.variantPrice;
                                selling_plan_option.dataset.currentCurrency = option.currentCurrency;
                                selling_plan_option.dataset.sellingPlanId = option.sellingPlanId;
                                index == 0 && (selling_plan_option.selected = true);
                                _.selector.variant_selling_plan_selected.append(selling_plan_option);
                            })                                
                        }                            
                    }
                    const regular_price = parseInt(el.querySelector('input[type="radio"]').dataset.variantRefinedPrice) / 100;
                    const current_currency = el.querySelector('input[type="radio"]').dataset.currentCurrency;
                    _.state.regular.second_product = regular_price;
                    // Update prices: discount shows total, regular shows just diffuser (second product is free)
                    const total_before_discount = parseInt(_.state.regular.first_product) + parseInt(_.state.regular.second_product);
                    _.final.selling_plan.finalorderdiscount.textContent = `${current_currency}${total_before_discount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                    const final_regular_price = parseInt(_.state.regular.first_product);
                    _.final.selling_plan.finalorderregular.textContent = `${current_currency}${final_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                    _.final.selling_plan.finalplanname.textContent =`${_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].text}`;
                    _.selector.subscription_input.forEach(detail => {
                        if(detail.checked) {
                            if(detail.value !== 'one-time-purchase') {                               
                                const selling_plan_discount = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanPriceValue) * 0.01;
                                const refined_price = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.variantPrice) / 100;                               
                                const discounted_amount = refined_price * selling_plan_discount;
                                const final_discounted_amount = refined_price - discounted_amount;
                                _.final.second_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                _.final.selling_plan.subscription.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                _.state.discounted.second_product = final_discounted_amount;
                                _.final.selling_plan.finalorderdiscount.classList.remove('underline');
                                _.final.selling_plan.finalorderregular.classList.add('underline');
                                _.final.second_product.regular_price.classList.add('underline');
                                _.final.second_product.discount_price.classList.remove('underline');
                                detail.value = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
                                _.state.selling_plan = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
                            } else {
                                const one_time_purchase_discount = parseInt(detail.dataset.oneTimePurchaseDiscount) * 0.01;
                                const refined_price = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.variantPrice) / 100;                                
                                const discounted_amount = refined_price * one_time_purchase_discount;
                                const final_discounted_amount = refined_price - discounted_amount;
                                _.final.second_product.discount_price.textContent = `${current_currency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                _.state.discounted.second_product = final_discounted_amount;
                                _.final.selling_plan.finalorderdiscount.classList.add('underline');
                                _.final.selling_plan.finalorderregular.classList.remove('underline');
                                _.final.second_product.regular_price.classList.remove('underline');
                                _.final.second_product.discount_price.classList.add('underline');
                            }     
                        }
                    })
                }
            })
        }
        if(_.selector.next_steps.length > 0) {
            _.selector.next_steps.forEach(el => {
                el.addEventListener('click', event => {
                    _.selector.steps.forEach(step => {
                        if(parseInt(step.dataset.thisStep) == parseInt(event.target.closest("button").dataset.nextStep)) {
                            step.classList.add('active');
                        } else {
                            step.classList.remove('active');
                        }  
                        if( parseInt(event.target.closest("button").dataset.nextStep) == 2) {
                            let progress = 33.33;
                            const interval = setInterval(() => {
                                progress+= 1;
                                _.selector.step2_progressbar.value = progress;
                                if(progress >= 66) {
                                    clearInterval(interval);
                                }
                            }, 30);
                        }               
                        if( parseInt(event.target.closest("button").dataset.nextStep) == 3) {
                            let progress = 66.66;
                            const interval = setInterval(() => {
                                progress+= 1;
                                _.selector.step3_progressbar.value = progress;
                                if(progress >= 100) {
                                    clearInterval(interval);
                                }
                            }, 30);
                            // Apply discount code when reaching step 3
                            _.applyDiscountCode();
                        }
                    })
                })
            })
        }
        if(_.selector.prev_steps.length > 0) {
            _.selector.prev_steps.forEach(el => {
                el.addEventListener('click', event => {
                    _.selector.steps.forEach(step => {
                        if(parseInt(step.dataset.thisStep) == parseInt(event.target.closest("button").dataset.prevStep)) {
                            step.classList.add('active');
                        } else {
                            step.classList.remove('active');
                        }     
                        if( parseInt(event.target.closest("button").dataset.prevStep) == 2) {
                            let progress = 100;
                            const interval = setInterval(() => {
                                progress-= 1;
                                _.selector.step2_progressbar.value = progress;
                                if(progress <= 66) {
                                    clearInterval(interval);
                                }
                            }, 30);
                        }                    
                        if( parseInt(event.target.closest("button").dataset.prevStep) == 1) {
                            let progress = 66.66;
                            const interval = setInterval(() => {
                                progress-= 1;
                                _.selector.step1_progressbar.value = progress;
                                if(progress <= 33) {
                                    clearInterval(interval);
                                }
                            }, 30);
                        }                                      
                    })
                })
            })
        }
        if(_.selector.show_info.length > 0) {
            _.selector.show_info.forEach(el => {
                el.addEventListener('click', event => {
                    const show_info = event.target.closest('.products-picker').querySelector(`.product-description[data-rank-number="${event.target.dataset.rankNumber}"]`);
                    show_info && show_info.classList.toggle('active');      
                })
            })
        }
        if(_.selector.subscription_label.length > 0) {
            _.selector.subscription_label.forEach(el => {
                el.addEventListener('click', event => {
                    _.selector.subscription_label.forEach(label => {
                        label.classList.remove('active');
                    })
                    event.target.closest('label').classList.add('active');
                    if(event.target.closest('label').classList.contains('active')) {
                        // _.state.selling_plan = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
                        _.state.selling_plan = el.querySelector('input[type="radio"]').value;
                        if (_.state.selling_plan !== 'one-time-purchase') {
                            _.state.selling_plan = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
                        }
                    }
                })
                if(el.closest('label').classList.contains('active')) {
                    _.state.selling_plan = el.querySelector('input[type="radio"]').value;
                }
            })
        }
        if(_.selector.subscription_input.length > 0) {
            _.selector.subscription_input.forEach(el => {
                el.addEventListener('change', event => {
                    if(event.target.value === 'one-time-purchase') {
                        _.final.first_product.discount_price.classList.add('underline');
                        _.final.second_product.discount_price.classList.add('underline');
                        _.final.second_product.regular_price.classList.remove('underline');
                        _.final.selling_plan.finalorderdiscount.classList.add('underline');
                        _.final.selling_plan.finalorderregular.classList.remove('underline');
                        _.selector.variant_selling_plan_selected.disabled = true;
                    } else {
                        _.final.first_product.discount_price.classList.remove('underline');
                        _.final.second_product.discount_price.classList.remove('underline');
                        _.final.second_product.regular_price.classList.add('underline');
                        _.final.selling_plan.finalorderdiscount.classList.remove('underline');
                        _.final.selling_plan.finalorderregular.classList.add('underline');
                        _.selector.variant_selling_plan_selected.disabled = false;
                    }

                    // Re-apply discount code when purchase type changes (only on full template)
                    if (_.discount.delivery_frequency === 'full') {
                        _.applyDiscountCode();
                    }
                })
            })
        }
        if(_.selector.arrow_steps.length > 0) {
            _.selector.arrow_steps.forEach(el => {
                el.addEventListener('click', event => {
                    _.selector.steps.forEach(step => {
                        if(parseInt(step.dataset.thisStep) == parseInt(event.target.closest(".arrow").dataset.nextStep)) {
                            step.classList.add('active');
                        } else {
                            step.classList.remove('active');
                        }     
                        if( parseInt(event.target.closest(".arrow").dataset.nextStep) == 2) {
                            let progress = 33.33;
                            const interval = setInterval(() => {
                                progress+= 1;
                                _.selector.step2_progressbar.value = progress;
                                if(progress >= 66) {
                                    clearInterval(interval);
                                }
                            }, 30);
                        }               
                        if( parseInt(event.target.closest(".arrow").dataset.nextStep) == 3) {
                            let progress = 66.66;
                            const interval = setInterval(() => {
                                progress+= 1;
                                _.selector.step3_progressbar.value = progress;
                                if(progress >= 100) {
                                    clearInterval(interval);
                                }
                            }, 30);
                            // Apply discount code when reaching step 3
                            _.applyDiscountCode();
                        }
                    })
                })
            })
        }
        if(_.selector.final_order_purchase) {
            _.selector.final_order_purchase.addEventListener('click', () => {
               _.checkout();
            })
        }
        if(_.selector.variant_selling_plan_selected) {
            _.selector.variant_selling_plan_selected.addEventListener("change", event => {
                _.final.selling_plan.finalplanname.textContent = event.target.options[event.target.selectedIndex].text;
                const one_time_purchase_discount = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanPriceValue) * 0.01;
                const refined_price = parseInt(_.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.variantPrice) / 100;                                
                const discounted_amount = refined_price * one_time_purchase_discount;
                const final_discounted_amount = refined_price - discounted_amount;
                _.final.second_product.discount_price.textContent = `${event.target.options[event.target.selectedIndex].dataset.currentCurrency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                _.final.selling_plan.subscription.textContent = `${event.target.options[event.target.selectedIndex].dataset.currentCurrency}${final_discounted_amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                _.state.selling_plan = _.selector.variant_selling_plan_selected.options[_.selector.variant_selling_plan_selected.selectedIndex].dataset.sellingPlanId;
            })
        }
    }
    BuildYourStarterKit.prototype.applyDiscountCode = function() {
        var _ = this;
        let discountCode;

        // Determine which discount code to apply
        if (_.discount.delivery_frequency === 'subscription') {
            // Subscription-only template - always apply subscription discount
            discountCode = _.discount.subscription;
            console.log('TEST:: Applying subscription discount (subscription-only template):', discountCode);
        } else if (_.discount.delivery_frequency === 'full') {
            // Full template - check which option is selected
            let isSubscriptionSelected = false;
            _.selector.subscription_input.forEach(input => {
                if (input.checked && input.value !== 'one-time-purchase') {
                    isSubscriptionSelected = true;
                }
            });

            if (isSubscriptionSelected) {
                discountCode = _.discount.subscription;
                console.log('TEST:: Applying subscription discount (customer selected subscription):', discountCode);
            } else {
                discountCode = _.discount.onetime;
                console.log('TEST:: Applying one-time discount (customer selected one-time):', discountCode);
            }
        } else {
            // Fallback - no discount configuration
            console.log('TEST:: No discount configuration found, skipping discount application');
            return;
        }

        // Apply the discount code
        if (discountCode && discountCode !== '') {
            fetch('https://scentifyhome.com/discount/' + discountCode).then(function(response) {
                return response;
            }).then(function(response){
                console.log('TEST:: Discount code applied:', discountCode, response);
            }).catch(function(error) {
                console.log('TEST:: Error applying discount code:', error);
            });
        }
    }
    BuildYourStarterKit.prototype.checkout = async function() {
        var _ = this;
        _.selector.final_order_purchase.classList.add("active");
        var formData
        if(_.state.selling_plan !== "one-time-purchase") {
            formData = {
                    'items': [
                            {
                                'id': parseInt(_.state.first_product),
                                'quantity': 1
                            },
                            {
                                'id': parseInt(_.state.second_product),
                                'quantity': 1,
                                'selling_plan': parseInt(_.state.selling_plan)
                            }
                        ]
                    };           
        } else {
            formData = {
                'items': [
                        {
                            'id': parseInt(_.state.first_product),
                            'quantity': 1
                        },
                        {
                            'id': parseInt(_.state.second_product),
                            'quantity': 1
                        }
                    ]
                };           
        }
       await fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
         return response.json();
       })
       .then(data => {
       })
       .catch((error) => {
         console.error('Error:', error);
       })
       .finally(() => {
           window.location.href = '/checkout';
           _.selector.final_order_purchase.classList.remove("active");
       });           
    }
    BuildYourStarterKit = new BuildYourStarterKit;
}
BuildYourStarterKit()